import { ChartOptions } from 'chart.js';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getLineOptions = (_isMobile: boolean): ChartOptions<'line'> => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,
    layout: {
      padding: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      },
    },
    plugins: {
      title: {
        display: false,
      },
      legend: {
        align: 'center',
        position: 'top',
        labels: {
          pointStyle: 'circle',
          usePointStyle: true,
          padding: 10,
        },
      },
    },

    interaction: {
      mode: 'index' as const,
    },
  };
};
